<template>
  <div>
    <div v-if="selectAll" class="checkbox styled islet">
      <input
        :id="`select-all-${groupName}`"
        type="checkbox"
        :checked="allSelected"
        @click="onSelectAll"
      />
      <label :for="`select-all-${groupName}`">
        {{ selectAllLabel }}
      </label>
    </div>
    <div v-for="checkbox in group" :key="checkbox" class="checkbox styled">
      <input
        :id="inputName(checkbox)"
        v-model="checked"
        :name="inputName(checkbox)"
        :value="checkbox"
        type="checkbox"
      />
      <label :for="inputName(checkbox)">
        {{ checkbox }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupName: {
      type: String,
      required: true
    },
    group: {
      type: Array,
      required: true
    },
    selected: {
      type: Array,
      default: () => []
    },
    selectAll: {
      type: Boolean,
      default: true
    },
    selectAllLabel: {
      type: String,
      default: 'Select all'
    }
  },
  data() {
    return {
      checked: [...this.selected]
    };
  },
  computed: {
    allSelected() {
      return this.group.length === this.checked.length;
    }
  },
  watch: {
    checked() {
      const unchecked = this.group.filter(c => !this.checked.includes(c));

      this.$emit('selected', this.checked, unchecked);
    }
  },
  methods: {
    inputName(checkbox) {
      return `${this.groupName}[${checkbox}]`;
    },
    onSelectAll() {
      this.checked = this.allSelected ? [] : [...this.group];
    }
  }
};
</script>
